import { apiClient } from "../config";

async function createCommunity(data: any) {
  const res = await apiClient.post(`/admin/communities`, data);
  return res.data;
}

export default createCommunity;
